import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer";
import SupplierAllSale from "./AllOrders";

function SupplierCatalogue() {

  return (
    <NavigationDrawer>
      <SupplierAllSale />
    </NavigationDrawer>
  );
}

export default SupplierCatalogue;
